<template>
    <div class="service-wrap pt-20 pb-20">
        <div class="container">
            <div class="row mb-5">
            <div class="col-12">
                <!-- <h3 class="mb-2">Parcours spirituels et retraites</h3> -->

                <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead class="table-light">
                    <tr>
                        <th>Dates</th>
                        <th>Thèmes</th>
                        <th>Communicateurs</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in recollections" :key="index">
                        <td>{{ item.date }}</td>
                        <td>{{ item.theme }}</td>
                        <td>{{ item.communicateur }}</td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
            </div>



            <div class="row ">
                <div class="col-xl-4 col-lg-6 col-md-6" v-for="(article, index) in truncatedArticles" :key="index">
                    <div class="blog-card style1">
                        <div class="blog-img"  :style="{height:'277px', backgroundImage: `url(${getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'}"
                        >
                        </div>
                        <div class="blog-info" style="min-height: 250px;">
                            <ul class="blog-metainfo  list-style">
                                <li><i class="flaticon-user"></i> <router-link to="#">L' École d’Initiation Théologique et Pastorale</router-link></li>
                                <li><i class="flaticon-calendar"></i>{{ format_Date(article.datePublication)  }}</li>
                            </ul>
                            <h3><router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }">{{ article.titre }}</router-link></h3>
                            <router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }" class="link style1">Lire plus
                                <i class="flaticon-right-arrow"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
    name: 'ConferenceAvant',
    components: {
      PaginationComponent,

  },
  setup(){

    const articles = ref<Array<Article>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
   const recollections = ref([
  {
    date: '18 et 20 décembre 2025',
    theme: '« Et après le jubilé ? »',
    communicateur: 'Père Narcisse Bah-Kpêvi'
  },
  {
    date: '19 et 21 décembre 2024',
    theme: '« Pèlerins et témoins d’espérance »',
    communicateur: 'Père Albino Binazon'
  },
  {
    dates: '21 et 23 mars 2024',
    theme: '« Pour moi, vivre c’est le Christ » (Ph 1,21)',
    communicateur: 'Père Romuald Hounsa'
  },
  {
    date: '16 et 19 décembre 2023',
    theme: '« Je suis venu pour qu’ils aient la vie et la vie en abondance » (Jn 10,10)',
    communicateur: 'Père Nathanaël Dan'
  },
  {
    date: '17 et 20 décembre 2022',
    theme: '« Vous êtes le sel de la terre, la lumière du monde » (Mt 5,13-14)',
    communicateur: ''
  },
  {
    date: '07 et 09 avril 2022',
    theme: '« Comment être témoin du salut dans le monde de ce temps ? »',
    communicateur: 'Père Philippe Donou'
  },
  {
    date: '18 et 21 décembre 2021',
    theme: 'Le Seigneur vient : de quoi vient-il nous sauver ?',
    communicateur: 'Père Narcisse Bah-Kpêvi'
  },
  {
    date: '25 et 27 mars 2021',
    theme: 'Comment comprendre la semaine sainte, comment la vivre ?',
    communicateur: 'Père Saturnin Lawson'
  },
  {
    date: '19 et 22 décembre 2020',
    theme: 'Le Seigneur vient, prépare-toi à l’accueillir',
    communicateur: 'Père Guillaume Chogolou'
  },
  {
    date: '19 et 20 décembre 2019',
    theme: 'Temps de Noël : Quelle place l’Enfant-Dieu trouvera-t-il dans ton cœur ?',
    communicateur: 'Frère Maxime Janvier Djossa'
  },
  {
    dates: '20 au 22 septembre 2019',
    theme: '« Saisi par le Christ Jésus, je cours droit vers le but » (Ph 3,12-14)',
    communicateur: 'Père Ghislain Sanny'
  },
  {
    date: '11 et 12 avril 2019',
    theme: 'La croix : victoire de l’amour sur la haine',
    communicateur: 'Mgr Aristide Gonsallo, Père Jacques Gnonhossou, Père Didier Agondjihossou'
  },
  {
    date: '21 décembre 2018',
    theme: 'Le Verbe s’est fait chair, il a habité parmi nous',
    communicateur: 'Père Sobakin Raymond, Père Maxime Noudéhou, Père Crépin Magloire Acapovi'
  },
  {
    date: '22, 24 et 25 mars 2018',
    theme: 'La Pâque chrétienne et ses implications sociales',
    communicateur: 'Père Placide Augustin Houéssinon, Père Roger Sèvoh'
  }
]);



    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
        getTreeArticle(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/38?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        articles.value = data.data.data;
        console.log("fff",articles.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    const truncatedArticles = computed(() => {
        const maxLength = 100; 
        return articles.value.map(article => {
            if (article.titre.length > maxLength) {
            return {
                ...article,
                titre: article.titre.substring(0, maxLength) + '...'
            };
            }
            return article;
        });
    });

    // function getTreeArticle() {
    //   return ApiService.get(`/actualite/articles/22`)
    //     .then(({ data }) => {
    //       articles.value = data.data.data;
    //       console.log(articles.value);
    //       return data.data;
    //     })
    //     .catch(({ response }) => {
    //       error(response.message)
    //   });
    // }
    
    onMounted(() => {
        getTreeArticle();
    });

    return { 
        recollections,
        articles,
        getUrlApiForFiles,
        format_Date,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        truncatedArticles
    };
  },
});
</script>

<style scoped>
    .blog-card .blog-info h3 {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 15px;
    }
</style>